import { Card } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

/**
 * This is a temporary component which adds a 'selected' state that we'll use until we have a proper SelectCard component.
 */
export const AdvocateSelectCard: React.FC<Props> = ({ onClick, selected, children, className }) => {
	const placeholderBaseStyles =
		'bg-fill-inverse-strong! relative flex-1 cursor-pointer overflow-visible rounded-[11px] border-none w-full';

	return (
		<Card
			className={cn(placeholderBaseStyles, className, {
				'before:bg-gradient-stroke-interactive before:pointer-events-none before:absolute before:-inset-[2px] before:z-[-1] before:rounded-xl before:content-[""]':
					selected,
			})}
			elevation
			onClick={(e) => {
				e.preventDefault();
				onClick();
			}}
			data-qa="contribution-type-advocate"
			as="button"
		>
			{children}
		</Card>
	);
};

type Props = Readonly<{
	onClick: () => void;
	selected: boolean;
	children: React.ReactNode;
	className?: string;
}>;
